import React from "react";
import LegalLayout, { Section } from "../components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      title="利用規約"
      description="AdSche（TMS株式会社）が提供するサービスのご利用条件です。"
    >
      <Section>
        <h2>第1条（適用）</h2>
        <p>
          本規約は、TMS株式会社（以下「当社」）が提供する「Amazon広告バルク操作ツール（AdSche）」（以下「本サービス」）の利用条件を定めるものです。ユーザーは本規約に同意のうえ本サービスを利用するものとします。
        </p>
      </Section>

      <Section>
        <h2>第2条（利用登録）</h2>
        <ul>
          <li>所定の手続により利用登録を申請し、当社が承認した時点で利用契約が成立します。</li>
          <li>登録情報に虚偽・不備がある場合、当社は承認を保留・却下または契約を解除できるものとします。</li>
        </ul>
      </Section>

      <Section>
        <h2>第3条（料金・支払方法）</h2>
        <ul>
          <li>利用料金：月額 3,980円（税込）。</li>
          <li>新規登録時のみ初回30日間の無料トライアルが適用されます。</li>
          <li>再契約時は無料トライアルは適用されず、即時課金となります。</li>
          <li>支払い方法は Stripe を用いたクレジットカード決済とします。</li>
          <li>無料期間終了後は自動的に有料プランへ移行します。</li>
        </ul>
      </Section>

      <Section>
        <h2>第4条（禁止事項）</h2>
        <ul>
          <li>法令または公序良俗に違反する行為</li>
          <li>当社または第三者の権利・利益を侵害する行為</li>
          <li>本サービスの運営・ネットワークを妨害する行為</li>
          <li>不正アクセス、リバースエンジニアリング等の解析行為</li>
          <li>アカウントの譲渡・貸与・共有</li>
        </ul>
      </Section>

      <Section>
        <h2>第5条（サービス提供の停止等）</h2>
        <p>
          当社は、システム保守、障害、天災地変、外部サービス（Amazon Ads API / Stripe 等）の不具合等により、本サービスの全部または一部を事前通知なく停止・中断できるものとします。
        </p>
      </Section>

      <Section>
        <h2>第6条（免責）</h2>
        <ul>
          <li>本サービスの利用により生じた損害について、当社は一切の責任を負いません。</li>
          <li>当社は、本サービスに関し、特定目的適合性・完全性・有用性等について何ら保証しません。</li>
          <li>外部APIの仕様変更・停止により機能が一時的または恒久的に利用不能となる場合があります。</li>
        </ul>
      </Section>

      <Section>
        <h2>第7条（契約解除）</h2>
        <p>
          ユーザーが本規約に違反した場合、当社は事前の催告なくアカウント停止または契約解除を行うことができます。
        </p>
      </Section>

      <Section>
        <h2>第8条（規約の変更）</h2>
        <p>
          当社は本規約を変更できるものとし、変更後の規約は本サービス上に表示した時点で効力を生じます。
        </p>
      </Section>

      <Section>
        <h2>第9条（準拠法・管轄）</h2>
        <p>
          本規約は日本法に準拠し、紛争が生じた場合はさいたま地方裁判所を第一審の専属的合意管轄裁判所とします。
        </p>
      </Section>
    </LegalLayout>
  );
}